import lodashGet from 'lodash/get';
import { getAtomTypeFromNucleus } from '../general/getAtomTypeFromNucleus';
/**
 * Add experiment of certain type to experiments.
 *
 * @param {Experiments} experiments
 * @param {ExperimentsType} experimentsType
 * @param {string} type
 * @param {boolean} checkAtomType
 * @param {string} experimentKey
 */
export function addToExperiments(experiments, experimentsType, type, checkAtomType, experimentKey) {
    const _experiments = lodashGet(experiments, `${type}`, []) // don't consider DEPT etc. here
        .filter((_experiment) => {
        const hasValues = lodashGet(_experiment, type.includes('1D') ? 'ranges.values' : 'zones.values', []).length > 0;
        return checkAtomType === true
            ? getAtomTypeFromNucleus(_experiment.info.nucleus) ===
                experimentKey && hasValues
            : hasValues;
    });
    if (_experiments.length > 0) {
        experimentsType[experimentKey] = _experiments;
    }
}
//# sourceMappingURL=addToExperiments.js.map